export default __webpack_public_path__ + "static/media/feature-icon.26077e72.svg";